/**
 * Which cards a Feature Solutions row renders.
 *
 * The `feature_solutions` modular block holds two sources of cards:
 *  - `feature_solutions` (v1): a reference to one R - Feature Solutions entry, whose
 *    `feature_solutions` group holds the cards inline.
 *  - `feature_solutions_v2`: 1–3 references to reusable R - Feature Solution Instances,
 *    each one a card with the same fields as a v1 group item (ST-3878).
 *
 * v2 wins whenever it resolves to at least one card, so editors can switch a row over by
 * filling v2 and keep the v1 reference as the fallback.
 */

/**
 * A reference the Delivery API could not resolve (not included, or the instance is not
 * published to this environment) comes back as a `{ uid, _content_type_uid }` stub.
 */
const isResolvedCard = (card: any): boolean => !!card?.solution_title;

/**
 * Returns the row's cards as the same objects held in the CMS data, never copies: the
 * category-top partial resolves MPNs and prices on them, and the feature-solutions component
 * reads those results off the same objects (ST-3811).
 */
export function getFeatureSolutionCards(row: any): any[] {
    const v2 = row?.feature_solutions?.feature_solutions_v2;
    const v2Cards = Array.isArray(v2) ? v2.filter(isResolvedCard) : [];
    if (v2Cards.length) {
        return v2Cards;
    }
    const v1 = row?.feature_solutions?.feature_solutions?.[0]?.feature_solutions;
    return Array.isArray(v1) ? v1 : [];
}
